
// Helper function to build user selections string
export const buildUserSelections = (
  keyword: string,
  offerName: string
): string => {
  if (keyword && offerName) {
    return `keyword:${keyword}|offer:${offerName}`;
  }
  if (offerName) {
    return `offer:${offerName}`;
  }
  if (keyword) {
    return `keyword:${keyword}`;
  }
  return '';
};
